import { API_EXCEL, COMMON_ENUM } from "shared/constants";
const DEFAULT_EXCEL_SCREEN = {
  [API_EXCEL.TABLE_NAME]: "",
  [API_EXCEL.BOOK_MARKS]: "",
  [API_EXCEL.SAVE_BOOK_MARK]: false,
  [API_EXCEL.REPORT_NAME]: "",
  [API_EXCEL.REPORT_TITLE]: "",
  [API_EXCEL.START_ROW]: "",
  [API_EXCEL.START_COLUMN]: "",
  [API_EXCEL.BIG_DATA]: true,
  [API_EXCEL.DATA_OWNER]: COMMON_ENUM.C_SM_CTG_TMAP_EM,
  [API_EXCEL.NAME]: "",
  [API_EXCEL.EMAIL]: "",
  [API_EXCEL.ROLE_ID]: "",
};

const LOGICAL_OPR = [
  { cd: "AND", value: "AND" },
  { cd: "OR", value: "OR" },
  { cd: "LIKE", value: "LIKE" },
];

export { DEFAULT_EXCEL_SCREEN, LOGICAL_OPR };
